import React from "react";
import QMade from ".";
import useMedia from "react-use/lib/useMedia";

function QMadeComponent({ comp, params }) {
    return <QMade screen={comp.subtype} params={params} />;
}

export default QMadeComponent;
